<blaze-scroller [propagate]="false">
  <div class="table-popup-menu rounded m-8 p-8">
    <div class="table-popup-menu-header">
      <h3 class="table-popup-menu-title">
        <ng-content select="[title]" />
      </h3>
      <mat-icon svgIcon="icon_close_16" (click)="closePanel.emit()" />
    </div>
    <div class="table-popup-menu-content mt-20">
      <ng-content select="[content]" />
      <div class="table-popup-menu-buttons">
        <ng-content select="[buttons]" />
      </div>
    </div>
  </div>
</blaze-scroller>
